import {
  WithTooltips
} from "./chunk-TZ7NDB2R.mjs";
import {
  isString
} from "./chunk-ARWLRO3D.mjs";

// lib/components/icon/icon/icon.tsx
import classNames from "classnames";
import React, { useCallback } from "react";
import { jsx } from "@emotion/react/jsx-runtime";
var Icon = ({ tips, ...props }) => {
  const content = useCallback(
    ({ hoverSensor, setNodeRef }) => /* @__PURE__ */ jsx(SingleIcon, { ref: setNodeRef, ...hoverSensor, ...props }),
    [props]
  );
  return tips ? /* @__PURE__ */ jsx(WithTooltips, { ...tips, Content: content }) : /* @__PURE__ */ jsx(SingleIcon, { ...props });
};
var SingleIcon = React.forwardRef(
  function SingleIcon2({ iconName, color, className, ...props }, ref) {
    return /* @__PURE__ */ jsx(
      "span",
      {
        ref,
        className: classNames("icon", color && `has-text-${color}`, className),
        ...props,
        children: isString(iconName) ? /* @__PURE__ */ jsx("i", { className: iconName }) : /* @__PURE__ */ jsx("span", { className: "fa-stack", children: iconName.map((i) => /* @__PURE__ */ jsx("i", { className: i }, i)) })
      }
    );
  }
);
var ExpandIcon = ({ tips, isOpen, ...props }) => {
  return /* @__PURE__ */ jsx(
    Icon,
    {
      ...props,
      iconName: "fas fa-chevron-right",
      tips,
      style: {
        ...props.style,
        transform: `rotate(${isOpen ? "90deg" : "0deg"})`,
        transition: "transform 0.2s ease-in-out"
      }
    }
  );
};

export {
  Icon,
  ExpandIcon
};
